import React from 'react';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import LzXAutocompleteField from '@lz-components/forms/fields/AutocompleteField';
import LzXInputField from '@lz-components/forms/fields/InputField';
import LzXSelectField from '@lz-components/forms/fields/SelectField';
import { getFormattedAmount } from 'services/Utils';
import PartyModel from 'modules/Params/Parties/party.model';
import SalesInvoiceModel from './sales-invoice.model';
import SalesInvoiceDetailsComponent from './SalesInvoiceDetailsComponent';
import SalesInvoiceFBRSubmissionComponent from './SalesInvoiceFBRSubmissionComponent';
import SalesInvoiceImportExportComponent from './SalesInvoiceImportExportComponent';

const SalesInvoiceFormComponent = (props) => {

    const handleBuyerChange = (_, val) => {
        const updated = new SalesInvoiceModel(props.data);
        const rawData = Object.assign({ type: 1, code: '', name: '', address: '', province: '', strn: '', ntn: '', cnic: '' }, val);
        updated.buyer_type = rawData.type;
        updated.buyer_code = rawData.code;
        updated.buyer_name = rawData.name;
        updated.buyer_address = rawData.address;
        updated.buyer_province = rawData.province;
        updated.buyer_strn = rawData.strn;
        updated.buyer_ntn = rawData.ntn;
        updated.buyer_cnic = rawData.cnic;
        props.onChange(updated);
    };

    const handleInputChange = (key, val) => {
        props.onChange(
            new SalesInvoiceModel(
                Object.assign(
                    {},
                    props.data,
                    { [key]: val }
                )
            )
        );
    };

    return (
        <div className="lz-form-page lz-form-page-full lz-sales-invoice-entity">
            <Container>
                <Paper elevation={2} className='lz-form'>
                    <div className={props.data.is_fbr_registered ? 'make-disabled' : ''}>
                        <h3>Sales Invoice Main Information:</h3>
                        <Grid container spacing={2}>
                            <Grid item size={{ sm: 6 }}>
                                <LzXAutocompleteField fluid lazyLoad compact size="small" variant="outlined" maxLimit={10}
                                    label="Load Buyer data from an existing Buyer" placeholder="type to search..."
                                    name="buyer_id" value={props.data.buyer_id} onChange={handleBuyerChange} refTableName="parties"
                                    refFilterFieldKeys={['type', 'code', 'name', 'address', 'province', 'strn', 'ntn', 'cnic']}
                                />
                            </Grid>
                            <Grid item size={{ sm: 3 }}>
                                <LzXInputField fluid required labelShrinked compact size="small" variant="outlined" label="Invoice No."
                                    name="invoice_no" value={props.data.invoice_no} onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item size={{ sm: 3 }}>
                                <LzXInputField fluid required labelShrinked compact size="small" variant="outlined" type="date" label="Invoice Date"
                                    name="invoice_date" value={props.data.invoice_date} onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item size={{ sm: 3 }}>
                                <LzXSelectField fluid required noFirstOption labelShrinked compact size="small" variant="outlined" label="Buyer Type"
                                    name="buyer_type" value={props.data.buyer_type} options={PartyModel.getTypeOptions()} onChange={handleInputChange}
                                />
                            </Grid>
                            {/* <Grid item size={{ sm: 2 }}>
                            <LzXInputField fluid required labelShrinked compact size="small" variant="outlined" label="Buyer Code"
                                name="buyer_code" value={props.data.buyer_code} onChange={handleInputChange}
                            />
                        </Grid> */}
                            <Grid item size={{ sm: 3 }}>
                                <LzXInputField fluid required labelShrinked compact size="small" variant="outlined" label="Buyer Name"
                                    name="buyer_name" value={props.data.buyer_name} onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item size={{ sm: 6 }}>
                                <LzXInputField fluid required labelShrinked compact multiline size="small" variant="outlined" label="Buyer Address"
                                    name="buyer_address" value={props.data.buyer_address} onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item size={{ sm: 3 }}>
                                <LzXSelectField fluid required noFirstOption compact size="small" variant="outlined" label="Buyer Province"
                                    name="buyer_province" value={props.data.buyer_province} options={PartyModel.getProvinceOptions()}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item size={{ sm: 3 }}>
                                <LzXInputField fluid labelShrinked compact size="small" variant="outlined" label="Buyer STRN"
                                    name="buyer_strn" value={props.data.buyer_strn} onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item size={{ sm: 3 }}>
                                <LzXInputField fluid labelShrinked compact size="small" variant="outlined" label="Buyer NTN"
                                    name="buyer_ntn" value={props.data.buyer_ntn} onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item size={{ sm: 3 }}>
                                <LzXInputField fluid labelShrinked compact size="small" variant="outlined" label="Buyer CNIC"
                                    name="buyer_cnic" value={props.data.buyer_cnic} onChange={handleInputChange}
                                />
                            </Grid>
                            {/* <Grid item size={{ sm: 2 }}>
                            <LzXInputField fluid required labelShrinked compact size="small" variant="outlined" label="Consignee Code"
                                name="consignee_code" value={props.data.consignee_code} onChange={handleInputChange}
                            />
                        </Grid> */}
                            {/* <Grid item size={{ sm: 4 }}>
                            <LzXInputField fluid required labelShrinked compact size="small" variant="outlined" label="Consignee Name"
                                name="consignee_name" value={props.data.consignee_name} onChange={handleInputChange}
                            />
                        </Grid> */}
                            {/* <Grid item size={{ sm: 2 }}>
                            <LzXInputField fluid required labelShrinked compact size="small" variant="outlined" label="Transporter Code"
                                name="transporter_code" value={props.data.transporter_code} onChange={handleInputChange}
                            />
                        </Grid> */}
                            {/* <Grid item size={{ sm: 4 }}>
                            <LzXInputField fluid required labelShrinked compact size="small" variant="outlined" label="Transporter Name"
                                name="transporter_name" value={props.data.transporter_name} onChange={handleInputChange}
                            />
                        </Grid> */}
                            {/* <Grid item size={{ sm: 3 }}>
                            <LzXInputField fluid required labelShrinked compact size="small" variant="outlined" label="Confirmation Order No."
                                name="confirmation_order_no" value={props.data.confirmation_order_no} onChange={handleInputChange}
                            />
                        </Grid> */}
                            {/* <Grid item size={{ sm: 3 }}>
                            <LzXInputField fluid required labelShrinked compact size="small" variant="outlined" label="Reference No."
                                name="reference_no" value={props.data.reference_no} onChange={handleInputChange}
                            />
                        </Grid> */}
                            {/* <Grid item size={{ sm: 3 }}>
                            <LzXInputField fluid required labelShrinked compact size="small" variant="outlined" type="date" label="Reference Date"
                                name="reference_date" value={props.data.reference_date} onChange={handleInputChange}
                            />
                        </Grid> */}
                            {/* <Grid item size={{ sm: 3 }}>
                            <LzXInputField fluid required labelShrinked compact size="small" variant="outlined" label="Terms of Payment"
                                name="terms_of_payment" value={props.data.terms_of_payment} onChange={handleInputChange}
                            />
                        </Grid> */}
                        </Grid>

                        <SalesInvoiceDetailsComponent data={props.data} onChange={props.onChange} />

                        <h3 style={{ marginTop: 24, marginBottom: 32 }}>Other Information</h3>
                        <Grid container spacing={1}>
                            <Grid item size={{ sm: 6 }}>
                                <Grid container spacing={2}>
                                    {/* <Grid item size={{ sm: 6 }}>
                                    <LzXInputField fluid required labelShrinked compact size="small" variant="outlined" type="date" label="Despatch Date"
                                        name="despatch_date" value={props.data.despatch_date} onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item size={{ sm: 6 }}></Grid> */}
                                    <Grid item size={{ sm: 6 }}>
                                        <LzXInputField fluid required labelShrinked compact size="small" variant="outlined" label="Sales Tax Invoice No."
                                            name="sales_tax_invoice_no" value={props.data.sales_tax_invoice_no} onChange={handleInputChange}
                                        />
                                    </Grid>
                                    <Grid item size={{ sm: 6 }}></Grid>
                                    {/* <Grid item size={{ sm: 10 }}>
                                    <LzXInputField fluid labelShrinked compact size="small" variant="outlined" label="Notes"
                                        name="note" value={props.data.note} onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item size={{ sm: 2 }}></Grid> */}
                                    {props.data.id > 0 &&
                                        <Grid item size={{ sm: 12 }} sx={{ position: 'relative' }}>
                                            <InputLabel shrink className='lz-label'>FBR Invoicing</InputLabel>
                                            <SalesInvoiceFBRSubmissionComponent detailed
                                                fbrInvoiceNo={props.data.fbr_invoice_no}
                                                data={props.data}
                                                onChange={props.onChange}
                                            />
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>
                            <Grid item size={{ sm: 6 }}>
                                <Grid container spacing={1}>
                                    <Grid item size={{ sm: 12 }}>
                                        <div className="lz-invoice-foot-static-value">
                                            <div className="label">Gross Sales Value:</div>
                                            <div className="value">{getFormattedAmount(props.data.gross_sales_value, false)}</div>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ sm: 4 }}>
                                        <LzXInputField fluid required labelShrinked compact size="small" variant="outlined" type="number" label="Discount Rate (%)"
                                            name="discount_rate" value={props.data.discount_rate} onChange={handleInputChange}
                                        />
                                    </Grid>
                                    <Grid item size={{ sm: 8 }}>
                                        <div className="lz-invoice-foot-static-value">
                                            <div className="label">Discount:</div>
                                            <div className="value">{getFormattedAmount(props.data.discount_value, false)}</div>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ sm: 12 }}>
                                        <div className="lz-invoice-foot-static-value">
                                            <div className="label">Value Excluding S.Tax & WHT:</div>
                                            <div className="value">{getFormattedAmount(props.data.excl_st_wht_value, false)}</div>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ sm: 4 }}>
                                        <LzXInputField fluid required labelShrinked compact size="small" variant="outlined" type="number" label="Sales Tax Rate (%)"
                                            name="sales_tax_rate" value={props.data.sales_tax_rate} onChange={handleInputChange}
                                        />
                                    </Grid>
                                    <Grid item size={{ sm: 8 }}>
                                        <div className="lz-invoice-foot-static-value">
                                            <div className="label">Sales Tax:</div>
                                            <div className="value">{getFormattedAmount(props.data.sales_tax_value, false)}</div>
                                        </div>
                                    </Grid>
                                    {!props.data.is_buyer_registered &&
                                        <React.Fragment>
                                            <Grid item size={{ sm: 4 }}>
                                                <LzXInputField fluid required labelShrinked compact size="small" variant="outlined" type="number" label="Further Tax Rate (%)"
                                                    name="further_tax_rate" value={props.data.further_tax_rate} onChange={handleInputChange}
                                                />
                                            </Grid>
                                            <Grid item size={{ sm: 8 }}>
                                                <div className="lz-invoice-foot-static-value">
                                                    <div className="label">Further Tax:</div>
                                                    <div className="value">{getFormattedAmount(props.data.further_tax_value, false)}</div>
                                                </div>
                                            </Grid>
                                        </React.Fragment>
                                    }
                                    <Grid item size={{ sm: 4 }}>
                                        <LzXInputField fluid required labelShrinked compact size="small" variant="outlined" type="number" label="WHT Rate (%)"
                                            name="wht_rate" value={props.data.wht_rate} onChange={handleInputChange}
                                        />
                                    </Grid>
                                    <Grid item size={{ sm: 8 }}>
                                        <div className="lz-invoice-foot-static-value">
                                            <div className="label">WHT:</div>
                                            <div className="value">{getFormattedAmount(props.data.wht_value, false)}</div>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ sm: 12 }}>
                                        <div className="lz-invoice-foot-static-value" style={{ fontWeight: 'bold' }}>
                                            <div className="label">Value Including S.Tax & WHT:</div>
                                            <div className="value">{getFormattedAmount(props.data.incl_st_wht_value, false)}</div>
                                        </div>
                                    </Grid>
                                    {/* <Grid item size={{ sm: 12 }}>
                                    <LzXInputField fluid labelShrinked compact size="small" variant="outlined" type="number" label="Advance"
                                        name="advance_value" value={props.data.advance_value} onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item size={{ sm: 12 }}>
                                    <div className="lz-invoice-foot-static-value" style={{ fontWeight: 'bold' }}>
                                        <div className="label">Final Invoice Value:</div>
                                        <div className="value">{getFormattedAmount(props.data.invoice_value, false)}</div>
                                    </div>
                                </Grid> */}
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>

                    <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
                        <div style={{ flexGrow: 1 }}>
                            <SalesInvoiceImportExportComponent data={props.data} onChange={props.onChange} />
                        </div>
                        {!props.data.is_fbr_registered &&
                            <Button type='submit' variant='contained' style={{ marginLeft: 10 }} onClick={props.onSubmit}>Submit</Button>
                        }
                        <Button type='button' style={{ marginLeft: 10 }} onClick={props.onClose}>Close</Button>
                        {props.onReset && <Button type='button' style={{ marginLeft: 10 }} onClick={props.onReset}>Reset</Button>}
                        {props.onReload && <Button type='button' style={{ marginLeft: 10 }} onClick={props.onReload}>Reload</Button>}
                    </div>
                </Paper>
            </Container>
        </div>
    );

};

export default SalesInvoiceFormComponent;
